/**
 * @desc 自定义指令
 */

import Vue from 'vue'

let AppDirectives = {}

AppDirectives.install = (Vue) => {
  // 统计directive
  Vue.directive('trackTag', {
    bind (el, binding) {
      el.addEventListener('click', function () {
        Vue.prototype.$analysis && Vue.prototype.$analysis.trackEvent(null, binding.value)
      }, false)
    }
  })
  // 广告标签统计
  Vue.directive('aTag', {
    bind (el, binding) {
      el.addEventListener('click', function (e) {
        e.preventDefault()
        Vue.prototype.$analysis && Vue.prototype.$analysis.trackEvent(null, binding.value)
        let link = el.href
        setTimeout(() => {
          link && (window.location.href = link)
        }, 500)
      }, false)
    }
  })
  // number 输入
  Vue.directive('number', {
    bind (el) {
      el.input = function (e) {
        let value = e.target.value.replace(/[^0-9]/g, '')
        Vue.nextTick(() => {
          e.target.value = value
        })
      }
      el.addEventListener('input', el.input, false)
    },
    unbind (el) {
      el.removeEventListener('input', el.input, false)
      el.input = null
    }
  })
}

Vue.use(AppDirectives)
